// client/src/api/ApiInviteCodes.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/invite-codes/'

function unwrapData(responseJson) {
  return responseJson?.data ?? responseJson
}

async function getAll() {
  const response = await flex.flexFetch(endpoint + 'all')
  return unwrapData(await flex.handleResponse(response))
}

async function create(data) {
  const response = await flex.flexFetch(endpoint + 'create', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  return unwrapData(await flex.handleResponse(response))
}

async function disable(id) {
  const response = await flex.flexFetch(endpoint + 'disable', {
    method: 'PUT',
    body: JSON.stringify({ id }),
  })
  return unwrapData(await flex.handleResponse(response))
}

async function remove(id) {
  const response = await flex.flexFetch(endpoint + `delete?id=${id}`, {
    method: 'DELETE',
  })
  return unwrapData(await flex.handleResponse(response))
}

const ApiInviteCodes = { getAll, create, disable, remove }
export default ApiInviteCodes
